import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import Error from "./components/error/Error";
import { usePymChild } from "./hooks/usePymChild";
import { useConfigLoader } from "./hooks/useConfigLoader";
import "./App.css";

const App: React.FC = () => {
  usePymChild();
  const config = useConfigLoader();

  if (!config) return <div>Loading configuration...</div>;
  console.log('Config:', config);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home config={config} />} />
        <Route path="/error" element={<Error config={config} />} />
      </Routes>
    </Router>
  );
};

export default App;
